import React from "react";
import { Link } from "react-router-dom";
import config from "./../../utils/const";

import "./style.scss";

const Buttom = props => {
  const addClass = props["data-class"];
  return (
    <Link className={`btn-donation btn-donation--green ${addClass ? addClass : ""}`} onClick={props.onClick} {...props}>
      {props.text || props.children}
    </Link>
  );
};

Buttom.defaultProps = {
  text: "Voltar para Home",
  to: config.url,
  onClick: () => {}
};

export default Buttom;
